import React from "react";
import { NavLink } from "react-router-dom";
import userIcon from "../../assets/images/icons/user-info.png";
import wishlistIcon from "../../assets/images/icons/wishlist-menu.png";
import assignedPropIcon from "../../assets/images/icons/assigned-property-menu.png";
import revenue from "../../assets/images/icons/revenue.png";
import logout from "../../assets/images/icons/logout-1.png";
import secure from "../../assets/images/icons/secure-1.png";
import information from "../../assets/images/icons/information.png";
import feedbackIcon from "../../assets/images/icons/reviews-menu.png";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import { clearAuthTokens } from "../../utils/authTokens";

const OwnerSideBar = () => {
  const navigate = useNavigate();

  const { setAuthentication } = useUser();
  const handleLogout = () => {
    clearAuthTokens();
    setAuthentication(null);
    navigate("/");
    window.location.reload();
  };
  return (
    <div className="my-account-sidebar">
      <ul className="sidebar-list">
        <li>
          <NavLink to="properties">
            <img src={assignedPropIcon} alt="assign-property" /> My Properties
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="owner-property">
            <img src={assignedPropIcon} alt="" /> Properties
          </NavLink>
        </li> */}
        <li>
          <NavLink to="photos">
            <img src={wishlistIcon} alt="wishlist" /> Photos
          </NavLink>
        </li>
        <li>
          <NavLink to="my-expenses">
            <img src={assignedPropIcon} alt="expenses" /> My Expenses
          </NavLink>
        </li>
        <li>
          <NavLink to="revenue">
            <img src={revenue} alt="revenue" />
            Revenue
          </NavLink>
        </li>
        <li>
          <NavLink to="owner-bank-details">
            <img src={information} alt="bank-details" /> Bank Details
          </NavLink>
        </li>

        <li>
          <NavLink to="owner-profile-docs">
            <img src={feedbackIcon} alt="profile-docs" /> Documents
          </NavLink>
        </li>
        <li>
          <NavLink to="ownerprofile">
            <img src={userIcon} alt="ownerprofile" /> My Profile
          </NavLink>
        </li>
        <li>
          <NavLink to="owner-change-password">
            <img src={secure} alt="change-password" /> Change Password
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="owner-profile-agreement">
            <img src={billsIcon} alt="" /> Agreement Details
          </NavLink>
        </li> */}

        <li>
          <NavLink to="/" onClick={handleLogout}>
            <img src={logout} alt="logout" /> Logout
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default OwnerSideBar;
